import "./App.css";
import Home from "./pages/Home";
import Watchlist from "./pages/Watchlist";
import Join from "./pages/Join";
import Community from "./pages/Community";
import Ventures from "./pages/Ventures";
import Header from './components/Header.js';
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Bootstrap
import Container from "react-bootstrap/Container";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Container>
          <Header/>
          <Routes>
            <Route path="/" element={<Home/>}/>
            <Route path="/things" element={<Watchlist/>}/>
            <Route path="/join" element={<Join/>}/>
            <Route path="/community" element={<Community/>}/>
            <Route path="/ventures" element={<Ventures/>}/>
          </Routes>
        </Container>
      </BrowserRouter>
    </div>
  );
}

export default App;
